"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = TextEditor;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function autoFocusAndSelect(input) {
  input === null || input === void 0 ? void 0 : input.focus();
  input === null || input === void 0 ? void 0 : input.select();
}

function TextEditor(_ref) {
  var row = _ref.row,
      column = _ref.column,
      onRowChange = _ref.onRowChange,
      onClose = _ref.onClose;
  return /*#__PURE__*/_react["default"].createElement("input", {
    ref: autoFocusAndSelect,
    value: row[column.key] || "",
    onChange: function onChange(event) {
      return onRowChange(_objectSpread(_objectSpread({}, row), {}, _defineProperty({}, column.key, event.target.value)));
    },
    onBlur: function onBlur() {
      return onClose(true);
    },
    type: "text",
    style: {
      width: "100%",
      height: "100%",
      padding: "0px 6px 0 6px"
    }
  });
}

TextEditor.propTypes = {
  row: _propTypes["default"].object,
  column: _propTypes["default"].object,
  onRowChange: _propTypes["default"].func,
  onClose: _propTypes["default"].func
};